// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"248":"1597ff9d89c81638","445":"1d12ce5a989c7f2a","868":"65859a004311a991","971":"67650f0f8f17de37"}[chunkId] + ".js";
};